import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { DbclistPage } from './dbclist';

@NgModule({
  declarations: [
    DbclistPage,
  ],
  imports: [
    IonicPageModule.forChild(DbclistPage),
  ],
})
export class DbclistPageModule {}



// WEBPACK FOOTER //
// ./src/pages/dbclist/dbclist.module.ts